document.addEventListener('DOMContentLoaded', function() {
  (function($) {
    $(document).ready(function() {
      // Unbind the 'cart:updated' event to ensure only one event handler is active
      $(document).off('cart:updated').on('cart:updated', function(event, cart) {
        console.log('cart:updated event triggered');
        if (theme.ShippingPromotion && typeof theme.ShippingPromotion.update === 'function') {
          theme.ShippingPromotion.update();
        }
      });

      // Hook into the 'input' event on the quantity input fields with debounce
      $(document).on('input', 'input[name="updates[]"], input[name="quantity"]', debounce(function() {
        // Perform AJAX request to update the cart
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          dataType: 'json',
          success: function(response) {
            console.log('AJAX request successful');
            // Trigger the 'cart:updated' event after the cart is updated
            $(document).trigger('cart:updated', response);
          },
          error: function(xhr, status, error) {
            console.log('AJAX request error:', error);
          }
        });
      }, 500)); // Specify the delay (in milliseconds) for debouncing

      // Debounce function implementation
      function debounce(func, delay) {
        let timeoutId;
        return function() {
          const context = this;
          const args = arguments;
          clearTimeout(timeoutId);
          timeoutId = setTimeout(function() {
            func.apply(context, args);
          }, delay);
        };
      }
    });
  })(jQuery);
});
